export default __webpack_public_path__ + "static/media/programImgSmall.22628733.svg";